/**
 * @generated SignedSource<<8218efba28f07347aec60a84de239c17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MeasurementTemplatesInputQuery$variables = {};
export type MeasurementTemplatesInputQueryVariables = MeasurementTemplatesInputQuery$variables;
export type MeasurementTemplatesInputQuery$data = {
  readonly measurementTemplates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
};
export type MeasurementTemplatesInputQueryResponse = MeasurementTemplatesInputQuery$data;
export type MeasurementTemplatesInputQuery = {
  variables: MeasurementTemplatesInputQueryVariables;
  response: MeasurementTemplatesInputQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MeasurementTemplateConnection",
    "kind": "LinkedField",
    "name": "measurementTemplates",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MeasurementTemplateEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeasurementTemplate",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeasurementTemplatesInputQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MeasurementTemplatesInputQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c7b32d0b69f23f7e49e4ce88ae021041",
    "id": null,
    "metadata": {},
    "name": "MeasurementTemplatesInputQuery",
    "operationKind": "query",
    "text": "query MeasurementTemplatesInputQuery {\n  measurementTemplates {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4b41421fa05f2677b595fdf812de37dd";

export default node;
